import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "map-footer" }
const _hoisted_2 = { class: "scroll-map" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]

import { computed } from 'vue';
    import ChevronLeftIcon from '@/components/commons/icons/ChevronLeftIcon.vue';
    import { landPlotStore } from '@/store/modules/LandPLot';
    import { cardSettingsStore } from '@/store/modules/CardSettings';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MapFooter',
  setup(__props) {

    const scrollEnable = computed(() => {
        const vw = cardSettingsStore.SCROLL_DATA_OBJECT.vw;

        if (!vw) return false;

        return cardSettingsStore.MAP_DOM_RECT.width < vw;
    });

    const isReachedLeftLimit = computed(() => {
        return cardSettingsStore.CURRENT_TRANSLATE_X >= 0;
    });

    const isReachedRightLimit = computed(() => {
        return (
            cardSettingsStore.CURRENT_TRANSLATE_X <=
            cardSettingsStore.SCROLL_DATA_OBJECT.Xmax
        );
    });

    function scrollToLeft() {
        if (isReachedLeftLimit.value) return;

        cardSettingsStore.SET_TRANSLATE_X(cardSettingsStore.TRANSLATE_X + 100);
    }

    function scrollToRight() {
        if (isReachedRightLimit.value) return;

        cardSettingsStore.SET_TRANSLATE_X(cardSettingsStore.TRANSLATE_X - 100);
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "scroll-map__btn",
        disabled: isReachedLeftLimit.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollToLeft()))
      }, [
        _createVNode(ChevronLeftIcon)
      ], 8, _hoisted_3),
      _createElementVNode("button", {
        class: "scroll-map__btn scroll-map__btn--right",
        disabled: isReachedRightLimit.value,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (scrollToRight()))
      }, [
        _createVNode(ChevronLeftIcon)
      ], 8, _hoisted_4)
    ], 512), [
      [_vShow, scrollEnable.value]
    ])
  ]))
}
}

})